module.exports = __webpack_public_path__ + "front/img/10_9.271840d4.png";